import React from "react";

import Main from "./Components/Main"

import "./style.scss";

const PCSList = () => {


    return (
        <div className="bpl-container">
            <Main />
        </div>
    );
};

export default React.forwardRef(PCSList);
